import { useMemo } from "react";

import { inject } from "../../lib/itn-ui-kit/services/service-container";

const useService = (serviceName) => {
  return useMemo(() => inject(serviceName), [serviceName]);
};

export default useService;
